export const SET_MOCK_DATA = 'editor-mock-button/SET_MOCK_DATA';
export const SHOW_MOCK_DIALOG = 'editor-mock-button/SHOW_MOCK_DIALOG';
export const HIDE_MOCK_DIALOG = 'editor-mock-button/HIDE_MOCK_DIALOG';

export const setMockData = (method, path, example) => ({
  type: SET_MOCK_DATA,
  payload: { method, path, example },
});

export const showMockDialog = () => ({
  type: SHOW_MOCK_DIALOG,
});

export const hideMockDialog = () => ({
  type: HIDE_MOCK_DIALOG,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const handleUseForMock = (method, path, example) => (dispatch, getState) => {
  // Set the mock data
  dispatch(setMockData(method, path, example));

  // Show dialog/alert with the information
  dispatch(showMockDialog());

  // For now, we'll use window.alert. This can be replaced with a modal later
  const exampleStr = typeof example === 'object' ? JSON.stringify(example, null, 2) : example;

  // eslint-disable-next-line no-alert
  window.alert(`Mock Configuration:
Method: ${method.toUpperCase()}
Path: ${path}
Example: 
${exampleStr}`);

  // Log for debugging (disable ESLint for this line)
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('Use for mock:', {
      method: method.toUpperCase(),
      path,
      example,
    });
  }
};
